import { pageLinks } from "../data"
import PageLink from "./PageLink"

function PageLinks({ parentClass, itemClass }) {
    return (
        <ul className={parentClass} id="nav-links">
            {pageLinks.map((link) => {

                return (
                    // <li href={href} className={itemClass} key={id}>{text}</li>
                    <PageLink key={link.id} link={link} itemClass={itemClass} />
                )
            })}
        </ul>
    )
}

export default PageLinks